export let PanoramaInteractions = /*#__PURE__*/function (PanoramaInteractions) {
  PanoramaInteractions["DeliverySectionUpdateSelectedDeliveryOption"] = "delivery-section-update-selected-delivery-option";
  PanoramaInteractions["DeliverySectionControllerInit"] = "delivery-section-controller-init";
  PanoramaInteractions["DeliverySectionOnDataChanged"] = "delivery-section-on-data-changed";
  PanoramaInteractions["DeliverySectionLoadDeliveryOptions"] = "delivery-section-load-delivery-options";
  return PanoramaInteractions;
}({});
export const FreeShippingCouponType = 'FreeShipping';
export const DEFAULT_LANG = 'en-US';
export const DEFAULT_CURRENCY = 'USD';
//# sourceMappingURL=consts.js.map